import React from "react";
import { TbCategory2 } from "react-icons/tb";
import { SiBrandfolder } from "react-icons/si";
import { BsFillTagsFill } from "react-icons/bs";
import { LuLayoutDashboard, LuDollarSign } from "react-icons/lu";
import { useTranslation } from "react-i18next";

const ProductsNavbar = ({ tabActive, setTabActiive , className }) => {
  const [t, i18n] = useTranslation("global");
  const isRTL = i18n.dir() === "rtl";

  const tabs = [
    {
      key: "Products",
      label: t("product.productsServices"),
      icon: <LuLayoutDashboard size={22} />,
    },
    {
      key: "Prices",
      label: t("product.productsPrices"),
      icon: <LuDollarSign size={22} />,
    },
    {
      key: "Categories",
      label: t("product.categories"),
      icon: <TbCategory2 size={22} />,
    },
    {
      key: "Brands",
      label: t("product.brands"),
      icon: <SiBrandfolder size={20} />,
    },
    {
      key: "Tags",
      label: t("product.tags"),
      icon: <BsFillTagsFill size={20} />,
    },
  ];

  return (
    <div className={`w-full mt-4 ${className}`}>
      <div className="flex flex-wrap gap-2 bg-white p-2 rounded-2xl border border-slate-200 shadow-sm">

        {tabs.map((tab) => {
          const active = tabActive === tab.key;

          return (
            <button
              key={tab.key}
              onClick={() => setTabActiive(tab.key)}
              className={`
                flex-1 min-w-[160px]
                flex items-center justify-center gap-2
                px-4 py-3 rounded-xl
                transition-all duration-300
                border
                ${
                  active
                    ? "bg-[#251658] text-white border-[#251658] shadow-md"
                    : "bg-slate-50 text-[#251658] border-transparent hover:border-[#251658]/20 hover:bg-[#251658]/5"
                }
              `}
            >
              <span
                className={`transition-all duration-300 ${
                  active ? "scale-110" : ""
                }`}
              >
                {tab.icon}
              </span>

              <span className="text-sm font-medium whitespace-nowrap">
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ProductsNavbar;